import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsAsAdminParams,
  GetMarathonsAsAdminResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathonsAsAdmin = createAsyncThunk<
  GetMarathonsAsAdminResponse,
  GetMarathonsAsAdminParams
>(
  "marathons/getMarathonsAsAdmin",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonsAsAdmin({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting marathons as admin", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting marathons as admin", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
